import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";

import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import { ReactComponent as DownArrowSvg } from '../../../image/DownArrow.svg';

export default function SelectStatusBox(props) {
  const {
    isClickedValidSorting,
    isClickedInvalidSorting,
    setIsClickedValidSorting,
    setIsClickedInvalidSorting
  } = props;

  const { t } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const [isClicked, setIsClicked] = useState(false);

  const ButtonRef = useRef(null);
  const SelectBoxRef = useRef(null);

  // 컴포넌트 외부 클릭시 이벤트를 받기위한 리스너 연결
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 컴포넌트 외부 클릭시 실행
  function onClickOutSide(e) {
    if (SelectBoxRef.current !== e.target 
      && !SelectBoxRef.current.contains(e.target)
      && ButtonRef.current !== e.target 
      && !ButtonRef.current.contains(e.target)) {
        setIsClicked(false);
    }
  }

  return (
    <StatusBoxWrapper>
      <StatusBox ref={ButtonRef} isClicked={isClicked} onClick={() => setIsClicked(!isClicked)}>
        <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={isClicked ? theme.primary : theme.text} hover='pointer'>{t('messageSend.memberSelect.filter.status')}</Text>
        {
          (!isClickedValidSorting && !isClickedInvalidSorting) &&
          <ArrowWrapper isClicked={isClicked}>
            <StyledDownArrow width={10} height={6} color={theme.text} />
          </ArrowWrapper>
        }
        {
          (isClickedValidSorting || isClickedInvalidSorting) &&
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={isClicked ? theme.primary : theme.text} hover='pointer'>:</Text>
        }
        {
          isClickedValidSorting &&
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={isClicked ? theme.primary : theme.text} hover='pointer'>{isClickedInvalidSorting ? t('messageSend.memberSelect.filter.valid') + ',' : t('messageSend.memberSelect.filter.valid')}</Text>
        }
        {
          isClickedInvalidSorting &&
          <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={isClicked ? theme.primary : theme.text} hover='pointer'>{t('messageSend.memberSelect.filter.expired')}</Text>
        }
      </StatusBox>
      <SelectBox ref={SelectBoxRef} isClicked={isClicked} isDark={isDark}>
        <Option onClick={() => setIsClickedValidSorting(!isClickedValidSorting)}>
          <CheckBox isClicked={isClickedValidSorting} />
          <Text style={{ marginTop: '-2px' }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='pointer'>{t('messageSend.memberSelect.filter.valid')}</Text>
        </Option>
        <Option onClick={() => setIsClickedInvalidSorting(!isClickedInvalidSorting)}>
          <CheckBox isClicked={isClickedInvalidSorting} />
          <Text style={{ marginTop: '-2px' }} fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.text} hover='pointer'>{t('messageSend.memberSelect.filter.expired')}</Text>
        </Option>
      </SelectBox>
    </StatusBoxWrapper>
  )
}

const StatusBoxWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;
`;

const StatusBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 4px;

  height: 20px;

  gap: 4px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.line}`};
  border-radius: 5px;
  background-color: ${props => props.isClicked ? props.theme.subBackground : props.theme.buttonFill};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const ArrowWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 10px;
  height: 6px;

  transition: all 0.3s ease-in-out;

  transform: ${props => props.isClicked ? `rotateZ(-180deg)` : `rotateZ(0deg)`};
`;

const StyledDownArrow = styled(DownArrowSvg)`
  & path {
    stroke: ${props => props.color};
  }

  transition: all 0.3s ease-in-out;
`;

const SelectBox = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: center;

  margin-top: 26px;

  width: 88px;
  height: ${props => props.isClicked ? `70px` : `0px`};

  box-shadow: ${props => props.isDark ? 'none' : '0px 40px 50px rgba(240, 232, 227, 0.5)'};
  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};

  overflow: hidden;

  transition: all 0.3s ease-in-out;
`;

const Option = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 0px 0px 6px;

  width: calc(100% - 6px);
  height: 35px;

  gap: 6px;
  
  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const CheckBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 16px;
  height: 16px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.subText}`};
  border-radius: 5px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.hover};
  }

  transition: all 0.3s ease-in-out;
`;